import { render } from "./bettingList.vue?vue&type=template&id=286a101a&scoped=true"
import script from "./bettingList.vue?vue&type=script&lang=js"
export * from "./bettingList.vue?vue&type=script&lang=js"

import "@/styles/common.css?vue&type=style&index=0&id=286a101a&scoped=true&lang=css"
import "@/styles/subcommon.css?vue&type=style&index=1&id=286a101a&scoped=true&lang=css"
import "@/styles/striNew.css?vue&type=style&index=2&id=286a101a&scoped=true&lang=css"
import "./bettingList.vue?vue&type=style&index=3&id=286a101a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-partnerpage-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-286a101a"]])

export default __exports__